import React from 'react'
import { func, shape } from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Autosuggest, QuickGlanceOverlay, QuickGlanceHeader, QuickGlanceContent } from '@fs/zion-ui'
import { useDSCDispatch } from '../../../state/DSCStore'
import { useRegionLanguage } from '../hooks/hooks'

export default function AAMCountrySelector({ overlay }) {
  const { t } = useTranslation()
  const countryLanguageOptions = useRegionLanguage(t)
  const dispatch = useDSCDispatch()

  const suppressAutocomplete = (event) => {
    event.target.setAttribute('autocomplete', 'disabled')
  }

  const onSuggestionSelected = (selection) => {
    if (selection) {
      dispatch({
        type: 'UPDATE_LANGUAGE',
        data: {
          countryLang: selection,
        },
      })
      overlay.close()
      window.location.reload()
    }
  }

  const autoSuggestProps = {
    placeholder: t('aam-landing-validation-select-country-language'),
    suggestions: countryLanguageOptions,
    onSuggestionSelected,
  }

  return (
    <QuickGlanceOverlay {...overlay} fullscreen>
      <QuickGlanceHeader heading={t('aam.content.country.select', 'Select A Different Country Or Language')} />
      <QuickGlanceContent>
        <div style={{ height: '300px' }}>
          <Autosuggest
            inputProps={{
              onFocus: suppressAutocomplete,
            }}
            {...autoSuggestProps}
          />
        </div>
      </QuickGlanceContent>
    </QuickGlanceOverlay>
  )
}

AAMCountrySelector.propTypes = {
  overlay: shape({
    close: func,
  }).isRequired,
}
